import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetMoveDetailsDriverQueryVariables = Types.Exact<{
  moveId: Types.Scalars['bigint']['input'];
}>;


export type GetMoveDetailsDriverQuery = { __typename?: 'query_root', dealer_viewable_driver_info: Array<{ __typename?: 'dealer_viewable_driver_info', avatar_url?: string | null, display_name?: string | null, driver_id?: number | null }> };


export const GetMoveDetailsDriverDocument = gql`
    query getMoveDetailsDriver($moveId: bigint!) {
  dealer_viewable_driver_info(where: {move_id: {_eq: $moveId}}) {
    avatar_url
    display_name
    driver_id
  }
}
    `;

/**
 * __useGetMoveDetailsDriverQuery__
 *
 * To run a query within a React component, call `useGetMoveDetailsDriverQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMoveDetailsDriverQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMoveDetailsDriverQuery({
 *   variables: {
 *      moveId: // value for 'moveId'
 *   },
 * });
 */
export function useGetMoveDetailsDriverQuery(baseOptions: Apollo.QueryHookOptions<GetMoveDetailsDriverQuery, GetMoveDetailsDriverQueryVariables> & ({ variables: GetMoveDetailsDriverQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMoveDetailsDriverQuery, GetMoveDetailsDriverQueryVariables>(GetMoveDetailsDriverDocument, options);
      }
export function useGetMoveDetailsDriverLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMoveDetailsDriverQuery, GetMoveDetailsDriverQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMoveDetailsDriverQuery, GetMoveDetailsDriverQueryVariables>(GetMoveDetailsDriverDocument, options);
        }
// @ts-ignore
export function useGetMoveDetailsDriverSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMoveDetailsDriverQuery, GetMoveDetailsDriverQueryVariables>): Apollo.UseSuspenseQueryResult<GetMoveDetailsDriverQuery, GetMoveDetailsDriverQueryVariables>;
export function useGetMoveDetailsDriverSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMoveDetailsDriverQuery, GetMoveDetailsDriverQueryVariables>): Apollo.UseSuspenseQueryResult<GetMoveDetailsDriverQuery | undefined, GetMoveDetailsDriverQueryVariables>;
export function useGetMoveDetailsDriverSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMoveDetailsDriverQuery, GetMoveDetailsDriverQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMoveDetailsDriverQuery, GetMoveDetailsDriverQueryVariables>(GetMoveDetailsDriverDocument, options);
        }
export type GetMoveDetailsDriverQueryHookResult = ReturnType<typeof useGetMoveDetailsDriverQuery>;
export type GetMoveDetailsDriverLazyQueryHookResult = ReturnType<typeof useGetMoveDetailsDriverLazyQuery>;
export type GetMoveDetailsDriverSuspenseQueryHookResult = ReturnType<typeof useGetMoveDetailsDriverSuspenseQuery>;
export type GetMoveDetailsDriverQueryResult = Apollo.QueryResult<GetMoveDetailsDriverQuery, GetMoveDetailsDriverQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/moves/queries/getMoveDetailsDriver.query.gql}
 */
export async function getMoveDetailsDriver(
  variables: GetMoveDetailsDriverQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetMoveDetailsDriverQuery['dealer_viewable_driver_info']>
export async function getMoveDetailsDriver(
  variables: GetMoveDetailsDriverQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetMoveDetailsDriverQuery>
export async function getMoveDetailsDriver(
  variables: GetMoveDetailsDriverQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetMoveDetailsDriverQuery['dealer_viewable_driver_info'] | GetMoveDetailsDriverQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetMoveDetailsDriverQuery>(
    GetMoveDetailsDriverDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.dealer_viewable_driver_info
}